import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/activity');

export const activity = {
	// 获取上传token
	getToken(id, params) {
		return http.get(`/${id}/uploadToken`, { params });
	},
};
